import Http from '../Http';
import {
  addVersion,
} from '../HelperAPI';

const baseUrl = `${process.env.VAPI_BASE_URL}/deviceattributes`;

export default {
  list: (data, options) => Http.post(`${baseUrl}/search`, data, options),
  getById: id => Http.get(`${baseUrl}/${id}`),
  history: (data, options) => Http.post(`${baseUrl}/history`, data, options),
  locations: (data, options) => Http.post(`${baseUrl}/locations`, data, options),
  create: data => Http.post(baseUrl, data),
  update: (data) => Http.put(`${baseUrl}/${data._id}`, data),
  reactivate: (data, options) => {
    options = addVersion('5.36.0', options);
    return Http.post(`${baseUrl}/${data._id}`, data, options);
  },
  deactivate: id => Http.delete(`${baseUrl}/${id}`),
};
